/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for transientSourceType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="transientSourceType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="module"/&gt; &lt;enumeration value="package"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class TransientSourceType extends Enum{

	enumValue = null;

	/**
	 * transient object from source module.
	 */
	static  MODULE = TransientSourceType.newLiteral("module");

	/**
	 * transient object from package.
	 */
	static  PACKAGE = TransientSourceType.newLiteral("package");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < TransientSourceType.values().length); ++i) {
			if (TransientSourceType.values()[i].enumValue == v) {
				return TransientSourceType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("TransientSourceType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/TransientSourceType.js